import ReminderFormCard from "@pathwright/web/src/modules/step/manage/ReminderFormCard"
import ScheduleFormCard from "@pathwright/web/src/modules/step/manage/ScheduleFormCard"
import { createCardRoutes } from "lib/core/routing/card-routing"
import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import path from "path-browserify"
import { loadResourcePath } from "path/middleware"

const basePath = "/library/:resourceSlug/:cohortId/:section/schedule/"
const cardRoutes = {
  schedule: {
    path: ":pathItemSourceId/",
    component: (props) => (
      <ScheduleFormCard
        card={props.card}
        cohortId={parseInt(props.match.params.cohortId)}
        sourceId={parseInt(props.match.params.pathItemSourceId)}
      />
    ),
    middleware: loadResourcePath,
    getDefaultLaunchedFrom: ({ location }) =>
      path.join(location.pathname, "../../"),
    childCards: {
      reminder: {
        path: "reminder/:reminderId?/",
        reversePath: "../../",
        component: (props) => (
          <ReminderFormCard
            card={props.card}
            id={parseInt(props.match.params.reminderId)}
            cohortId={parseInt(props.match.params.cohortId)}
            sourceId={parseInt(props.match.params.pathItemSourceId)}
            stepDateField={props.location.query.step_date}
          />
        ),
        middleware: loadResourcePath
      }
    }
  }
}

export default createCardRoutes(basePath, cardRoutes, LibraryResourceContainer)
